// extracted by css-extract-rspack-plugin
export default {"spaceLarge":"32px","container":"askai-typeahead__container___qU6Y8","inputWrap":"askai-typeahead__inputWrap___Jzi1s"};